<template>
    <v-app :dark="!dark" :light="dark" app>
        <v-content>
            <v-container fluid pa-0 ma-0
                         style="background-image: url('https://vorsi-home.s3.amazonaws.com/LiVolsi/Lightshow.gif');
                                background-size: 100% 107%; background-repeat: no-repeat; background-position-y: center;"
            >
                <v-layout row wrap fill-height>
                    <v-flex mt-3 mb-5
                            style="margin-left: auto; margin-right: auto; background-color: rgba(0, 0, 0, 0.1);
                            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.8);
                            border-radius: 0.8rem;
                            backdrop-filter: blur(8px);"
                            shrink>
                        <v-flex xs12 class="text-xs-center pt-5 px-5 pb-3">
                            <a href="https://tinyurl.com/4vpxmr6e">
                                <img
                                    src="https://i.imgur.com/R7OGG9I.jpeg"
                                    style="display:block; margin: 0 auto; width: -webkit-fill-available; max-width: 600px; max-height: 600px; box-shadow: 0 5px 10px rgba(0 0 0 / 80%); border-radius: 0.8rem;"
                                    alt=""
                                >
                            </a>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center" style="line-height: 50px !important">
                            <div class="headline font-weight-bold">Official Album Release on 9/16</div>
                            <div>
                                <a
                                    href="https://www.paypal.com/donate/?hosted_button_id=33VSGS4J5AK8L"
                                    style="text-decoration: none"
                                >
                                    <v-btn color="amber darken-4">
                                        CLICK HERE TO DONATE TO SUPPORT THE ARTIST
                                    </v-btn>
                                </a>
                            </div>
                        </v-flex>
                        <v-layout row wrap justify-center pb-5 pt-3>
                            <v-flex shrink px-3>
                                <a href="https://www.youtube.com/channel/UC6NDUDHKppocHSTITkI0txw"
                                   style="text-decoration: none;">
                                    <v-btn icon large>
                                        <v-icon large>
                                            mdi-youtube
                                        </v-icon>
                                    </v-btn>
                                </a>
                            </v-flex>
                            <v-flex shrink px-3>
                                <a href="https://www.instagram.com/livolsimusic" style="text-decoration: none;">
                                    <v-btn icon large>
                                        <v-icon large>
                                            mdi-instagram
                                        </v-icon>
                                    </v-btn>
                                </a>
                            </v-flex>
                            <v-flex shrink px-3>
                                <a href="https://music.apple.com/us/album/livolsi/1639423134?uo=4&app=itunes&at=1001lry3&ct=dashboard"
                                   style="text-decoration: none;">
                                    <v-btn icon large>
                                        <v-icon large>
                                            mdi-music
                                        </v-icon>
                                    </v-btn>
                                </a>
                            </v-flex>
                            <v-flex shrink px-3>
                                <a href="https://distrokid.com/hyperfollow/livolsi/livolsi-2"
                                   style="text-decoration: none;">
                                    <v-btn icon large>
                                        <v-icon large>
                                            mdi-spotify
                                        </v-icon>
                                    </v-btn>
                                </a>
                            </v-flex>
                            <v-flex shrink px-3>
                                <a href="https://www.tiktok.com/@paullivolsi" style="text-decoration: none;">
                                    <v-btn icon large>
                                        <icon-base
                                            style="color: #FFFFFF;"
                                            icon-color="#FFFFFF"
                                            viewbox="0 0 30 30"
                                        >
                                            <icon-tik-tok/>
                                        </icon-base>
                                    </v-btn>
                                </a>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-layout justify-center row wrap>
                <v-flex shrink class="text-xs-center pt-5 px-5">
                    <img
                        src="https://i.imgur.com/Rs4jTcC_d.webp?maxwidth=640&shape=thumb&fidelity=high"
                        style="display:block; margin: 0 auto; width: -webkit-fill-available; max-width: 600px; max-height: 600px; box-shadow: 0 5px 10px rgba(0 0 0 / 80%); border-radius: 0.8rem;"
                        alt=""
                    >
                </v-flex>
                <v-flex shrink class="text-xs-center">
                    <v-container class="subheading pt-5 px-5" style="max-width: 800px;">
                        <b>Paul LiVolsi - Guitar / Bass / Drums / Vocals</b> <br><br>

                        LiVolsi has officially begun to release his first studio album. <br><br>

                        Featuring the tracks Another Girl, The Backrooms & I Can't Be Satisfied. LiVolsi was recorded at
                        LiVolsi's studio (The Big Beats Inc. studio) in his hometown, Hudson Valley, NY. The ten tracks
                        were written, recorded, produced and mixed by LiVolsi. <br><br>

                        'LiVolsi' is a psychedelic rock experience, showcasing all of LiVolsi's talents as a musician
                        and producer. The music videos are recorded, filmed, produced and edited entirely by LiVolsi.
                        <br><br>

                        In support of the self titled first album, LiVolsi will release 10 music videos; one for each
                        song. <br><br>

                        LiVolsi's goal is to gain a following that will help him to headlined festivals and theatres
                        around the world and released more full length albums. As a writer and producer LiVolsi has
                        ambitions to collaborate with other artists.
                    </v-container>
                </v-flex>
            </v-layout>
            <v-layout justify-center row wrap>
                <v-flex shrink class="text-xs-center pt-5 px-5">
                    <img
                        src="https://i.imgur.com/CCgvAwG.jpeg"
                        style="display:block; margin: 0 auto; width: -webkit-fill-available; max-width: 800px;
                        box-shadow: 0 5px 10px rgba(0 0 0 / 80%); border-radius: 0.8rem;"
                        alt=""
                    >
                </v-flex>
                <v-flex shrink class="text-xs-center pt-5 px-5">
                    <img
                        src="https://i.imgur.com/ubuWX9U.jpeg"
                        style="display:block; margin: 0 auto; width: -webkit-fill-available; max-width: 800px;
                        box-shadow: 0 5px 10px rgba(0 0 0 / 80%); border-radius: 0.8rem;"
                        alt=""
                    >
                </v-flex>
                <v-flex shrink class="text-xs-center pt-5 px-5">
                    <img
                        src="https://i.imgur.com/Its5mTx.jpeg"
                        style="display:block; margin: 0 auto; width: -webkit-fill-available; max-width: 800px;
                        box-shadow: 0 5px 10px rgba(0 0 0 / 80%); border-radius: 0.8rem;"
                        alt=""
                    >
                </v-flex>
            </v-layout>
        </v-content>
        <div class="pt-5"></div>
        <vorsi-footer></vorsi-footer>
    </v-app>
</template>

<script>
import IconBase from '../components/icons/IconBase.vue'
import IconTikTok from '../components/icons/IconTikTok.vue'

export default {
    data: () => ({
        dark: false,
    }),
    components: {
        IconBase,
        IconTikTok,
    }
};
</script>
